
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return require("private-next-pages/privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy"])
      });
    }
  